/** Selectors for portal'd UI that may be opened from inside a calendar item
 * (rc-dropdown menus, ReactModal-based modals, react-tooltip, react-select
 * menus). Outside-click handlers should treat clicks inside these as still
 * "inside" rather than as a click-away. The [class*="__menu"] entry catches
 * react-select's menu portal/list/etc. regardless of classNamePrefix -
 * options are always descendants of the menu, so `closest()` finds the
 * menu ancestor. */
export const PORTAL_SELECTORS = [
  '.rc-dropdown',
  '.rc-trigger-popup',
  '.ReactModal__Overlay',
  '.ReactModal__Content',
  '.ReactModalPortal',
  '.react-tooltip',
  '[class*="__menu"]',
  /* 3-dot submenu popups (superset picker, pace picker) portal to body
   * with their own class names - not inside .rc-dropdown - so they
   * need explicit entries or clicking a color/pace closes the popover. */
  '.custom-submenu-supersetPicker',
  '.pace-dropdown',
  '.nested-submenu',
  /* Transposed add-exercise table's set-number superset picker also
   * portals to body with its own class - without this, choosing a
   * superset letter would close the popover. */
  '.transposed-superset-popover',
].join(',');

/**
 * Whether a click/mousedown target landed inside any portaled UI covered by
 * PORTAL_SELECTORS. Outside-click handlers should treat this as "inside"
 * even though the target isn't a DOM descendant of the triggering component.
 * @param {EventTarget} target - the DOM event's target
 * @returns {boolean}
 */
export const isInsidePortaledUi = (target) => Boolean(
  target?.closest && target.closest(PORTAL_SELECTORS),
);
